import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { IxellAPIService, IBillingV1 } from 'src/app/tools/api.service';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorService } from 'src/app/tools/error.service';
import { HeaderService } from 'src/app/tools/header.service';
import { Constants } from 'src/app/entities/Constants';
import { Utils } from 'src/app/tools/utils';

@Component({
    selector: 'app-adminlacourCommand',
    templateUrl: './adminlacourCommand.component.html',
    styleUrls: ['./adminlacourCommand.component.scss']
})
export class AdminlacourCommandComponent implements OnInit, OnDestroy {

    displayedColumnsDevis = ["orderDate", "codeUnisite", "socialReason", "country", "orderNumber", "nbProducts", "details", "devisValide"];
    displayedColumnsS4 = ["orderDate", "codeUnisite", "socialReason", "country", "orderNumber", "nbProducts", "amount", "waitPayment", "paymentInfo"];
    displayedColumnsS5 = ["orderDate", "sageCode", "codeUnisite", "socialReason", "country", "nbProducts", "amount", "facture", "finalEdit", "deliveryNotification"];
    displayedColumns: string[];

    // Sub
    private OrderSub: any;
    private activationInfoSub: any;
    private payementInfoSub: any;
    private generateValidationSub: any;
    private acceptPaymentSub: any;
    private notifySendingSub: any;

    // Objets et tableaux
    orderLight: IBillingV1;
    allOrder: IBillingV1[] = [];
    //orderOther: IBillingV1[] = [];
    orderVirementCheque: IBillingV1[] = [];
    orderDevis: IBillingV1[] = [];
    orderValid: IBillingV1[] = [];
    orderLst: IBillingV1[] = [];
    orderSource: any;

    //modif affichage modal
    payement: boolean = false;
    facturation: boolean = false;
    devis: boolean = false;

    actualId: number;
    order: IBillingV1;
    orderTotal = 0;

    // js pour les tab
    actualtab = '';
    actualpane = '';

    conserverRecherche: boolean = true;
    valSearch: string = ""; 

    languages = [
        { name: "German", txt: "scaleform.allemand" },
        { name: "English", txt: "scaleform.anglais" },
        { name: "Spanish", txt: "scaleform.espagnol" },
        { name: "French", txt: "scaleform.français" },
        { name: "Italian", txt: "scaleform.italien" },
        { name: "Dutch", txt: "scaleform.neerlandais" },
        { name: "Romanian", txt: "scaleform.roumain" },
        { name: "Portuguese", txt: "scaleform.portugais" },
        { name: "Polish", txt: "scaleform.polonais" },
        { name: "Turkish", txt: "scaleform.turc" }
    ];

    sageForm = new UntypedFormGroup({
        sageCode: new UntypedFormControl('', [Validators.required])
    });
    invoiceForm = new UntypedFormGroup({
        invoiceCode: new UntypedFormControl('', [Validators.required])
    });

    fdpDevisForm = new UntypedFormGroup({
        fdpDevis: new UntypedFormControl('', [Validators.required])
    });

    constructor(private api: IxellAPIService, private errorService: ErrorService, private formBuilder: UntypedFormBuilder, private headerService: HeaderService, private _snackBar: MatSnackBar, private route: ActivatedRoute, private router: Router) { }

    ngOnInit() {
        Utils.deleteStorageData();
        this.OrderSub = this.api.allOrders().subscribe(data => {
            if (data != null) {
                data.forEach(element => {
                    // Ajoute toutes les commandes au tableau
                    this.allOrder.push(element);
                    if (element.transStatus == 17 || element.transStatus == 18)
                        this.orderDevis.push(element);
                    else {
                        if (element.transStatus == 16)
                            this.orderVirementCheque.push(element);
                        else
                            if (element.transStatus == 2 || element.transStatus == 3)
                                this.orderValid.push(element);
                    }
                    this.orderLst = this.orderDevis;
                    this.orderSource = new MatTableDataSource(this.orderDevis);
                    this.displayedColumns = this.displayedColumnsDevis;
                });
            }
            if (this.OrderSub != null) this.OrderSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "allActivation", new Date().toString());
            if (this.OrderSub != null) this.OrderSub.unsubscribe();
        });

        let code = this.route.snapshot.paramMap.get('tab');
        if (code) {
            sessionStorage.setItem("adminCodeOrder", code);
            this.router.navigate(["login"]);
        } else {
            let adminCodeOrder: string = sessionStorage.getItem("adminCodeOrder");
            if (adminCodeOrder) {
                sessionStorage.removeItem("adminCodeOrder");
                this.headerService.verifyRole();
            }
        }
        // Pour afficher la flèche de retour
        this.headerService.changeCanBack(true);
        if (this.actualtab == '') {
            this.actualtab = "nav-devis-tab";
            this.actualpane = "nav-devis";
        }
        this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeLogo(null);
    }

    ngOnDestroy() {
        if (this.OrderSub != null) this.OrderSub.unsubscribe();
        if (this.activationInfoSub != null) this.activationInfoSub.unsubscribe();
        if (this.payementInfoSub != null) this.payementInfoSub.unsubscribe();
        if (this.generateValidationSub != null) this.generateValidationSub.unsubscribe();
        if (this.acceptPaymentSub != null) this.acceptPaymentSub.unsubscribe();
        if (this.notifySendingSub != null) this.notifySendingSub.unsubscribe();
    }

    applyFilter(filterValue: string) {
        this.orderSource.filter = filterValue.trim().toLowerCase();
    }

    openSnackBar(message: string, action: string) {
        // Petite notification
        this._snackBar.open(message, action, {
            duration: 5000,
            panelClass: ['blue-snackbar']
        });
    }

    //getData(status) {
    //  this.orderDevis = [];
    //  this.orderVirementCheque = [];
    //  this.orderValid = [];
    //  this.orderLst = [];
    //  this.orderSource = null;
    //  this.allOrder = [];
    //  this.orderLigh = this.api.allActivationBilling().subscribe(data => {
    //    if (data != null) {
    //      data.forEach(element => {
    //        // Ajoute toutes les activations au tableau
    //        this.allActivation.push(ActivationLight.parseToActivationLight(element));
    //        if (element.activationStatus == 1 || element.activationStatus == 2)
    //          this.activationStatus2.push(ActivationLight.parseToActivationLight(element));
    //        if (element.activationStatus == 3)
    //          this.activationStatus3.push(ActivationLight.parseToActivationLight(element));
    //        if (element.activationStatus == 4)
    //          this.activationStatus4.push(ActivationLight.parseToActivationLight(element));
    //        if (element.activationStatus == 5) {
    //          if (element.transStatus == 2)
    //            this.activationStatus5.push(ActivationLight.parseToActivationLight(element));
    //          else
    //            this.activationStatus4.push(ActivationLight.parseToActivationLight(element));
    //        }
    //        switch (status) {
    //          case "1"://devis
    //            this.orderDevis.sort((a, b) => { return Constants.compareDate(a.transDate, b.transDate, false); })
    //            this.displayedColumns = this.displayedColumnsDevis;
    //            this.orderLst = this.orderDevis;
    //            this.orderSource = new MatTableDataSource(this.orderDevis);
    //            break;
    //          case "4"://virement/chèque
    //            this.orderVirementCheque.sort((a, b) => { return Constants.compareDate(a.transDate, b.transDate, false); })
    //            this.displayedColumns = this.displayedColumnsS4;
    //            this.orderLst = this.orderVirementCheque;
    //            this.orderSource = new MatTableDataSource(this.orderVirementCheque);
    //            break;
    //          case "5"://dossiers complétés
    //            this.orderValid.sort((a, b) => { return Constants.compareDate(a.transDate, b.transDate, false); })
    //            this.displayedColumns = this.displayedColumnsS5;
    //            this.orderLst = this.orderValid;
    //            this.orderSource = new MatTableDataSource(this.orderValid);
    //            break;
    //        }
    //      });
    //    }
    //  }, error => {
    //    this.errorService.setErrorLog("API", error.status.toString() + " " + error.message, "allActivation", new Date().toString());
    //    if (this.activationLightSub != null) this.activationLightSub.unsubscribe();
    //  });
    //}

    toggleTab(status: string, pane: string, tab: string) {
        switch (status) {
            case "1"://devis
                this.orderDevis.sort((a, b) => { return Constants.compareDate(a.transDate.toString(), b.transDate.toString(), false); })
                this.displayedColumns = this.displayedColumnsDevis;
                this.orderLst = this.orderDevis;
                this.orderSource = new MatTableDataSource(this.orderDevis);
                break;
            case "4"://virement/chèque
                this.orderVirementCheque.sort((a, b) => { return Constants.compareDate(a.transDate.toString(), b.transDate.toString(), false); })
                this.displayedColumns = this.displayedColumnsS4;
                this.orderLst = this.orderVirementCheque;
                this.orderSource = new MatTableDataSource(this.orderVirementCheque);
                break;
            case "5"://dossiers complétés
                this.orderValid.sort((a, b) => { return Constants.compareDate(a.transDate.toString(), b.transDate.toString(), false); })
                this.displayedColumns = this.displayedColumnsS5;
                this.orderLst = this.orderValid;
                this.orderSource = new MatTableDataSource(this.orderValid);
                break;
        }
        document.getElementById(this.actualtab).classList.remove("active");
        document.getElementById(tab).classList.add("active");
        this.actualpane = pane;
        this.actualtab = tab;

        if (this.conserverRecherche) {
            this.applyFilter(this.valSearch);
        } else {
            this.valSearch = "";
        }
    }

    displayPayementInfo(id: number) {
        this.actualId = id;
        let modal = document.getElementById("Modal");
        this.payement = true;
        modal.style.display = "block";

        this.order = this.orderVirementCheque.find(i => i.billingID == this.actualId);
        if (this.order.fdpManuel > 0)
            this.order.shipping = this.order.fdpManuel;
    }

    displayDetails(id: number) {
        this.actualId = id;
        let modal = document.getElementById("Modal");
        this.devis = true;
        modal.style.display = "block";
        this.order = this.orderDevis.find(i => i.billingID == this.actualId);
        if (this.order.transStatus == 17 || this.order.transStatus == 18) {
            this.order.amountTotal = 0;
            this.order.lstBillDetails.forEach(elem => {
                this.order.amountTotal += elem.qty * elem.product.amountP
            })
            this.order.amountTotal = this.order.amountTotal + (this.order.amountTotal * this.order.tva / 100);
        }


        this.fdpDevisForm.setValue({
            fdpDevis: this.order.fdpManuel
        })
    }

    displayInfoOrder(id: number) {
        this.actualId = id;
        let modal = document.getElementById("Modal");
        this.facturation = true;
        modal.style.display = "block";

        // Remplis les input si il y a déjà une valeur
        let index = this.allOrder.findIndex(i => i.billingID == this.actualId);

        this.order = this.allOrder[index];

        this.sageForm.setValue({
            sageCode: this.order.sageCode
        })
        this.invoiceForm.setValue({
            invoiceCode: this.order.invoiceCode
        })
    }

    refreshOrderList(status: string) {
        this.orderVirementCheque = [];
        this.orderValid = [];
        this.orderDevis = [];
        this.allOrder.forEach(element => {
            if (element.transStatus == 17 || element.transStatus == 18)
                this.orderDevis.push(element);
            else if (element.transStatus == 16)
                this.orderVirementCheque.push(element);
            else if (element.transStatus == 2 || element.transStatus == 3)
                this.orderValid.push(element);
        });
        switch (status) {
            case "17": case "18":
                this.orderSource = new MatTableDataSource(this.orderDevis.slice());
                this.orderLst = this.orderDevis.slice();
                this.displayedColumns = this.displayedColumnsDevis;
                break;
            case "16":
                this.orderSource = new MatTableDataSource(this.orderVirementCheque.slice());
                this.orderLst = this.orderVirementCheque.slice();
                this.displayedColumns = this.displayedColumnsS4;
                break;
            case "2": case "3":
                this.orderSource = new MatTableDataSource(this.orderValid.slice());
                this.orderLst = this.orderValid.slice();
                this.displayedColumns = this.displayedColumnsS5;
                break;
        }
    }

    refreshTab() {
        this.orderVirementCheque = [];
        this.orderValid = [];
        this.orderLst = [];
        this.orderSource = null;
        this.allOrder = [];
        this.ngOnInit();
        switch (this.actualtab) {
            case "nav-devis-tab":
                this.refreshOrderList("17");
                setTimeout(() => { this.actualtab = "nav-devis-tab"; }, 50);
                break;
            case "nav-stat4-tab":
                this.refreshOrderList("16");
                setTimeout(() => { this.actualtab = "nav-stat4-tab" }, 50);
                break;
            case "nav-stat5-tab":
                this.refreshOrderList("2");
                setTimeout(() => { this.actualtab = "nav-stat5-tab"; }, 150);
                break;
        }
    }

    closeModal() {
        let Modal = document.getElementById("Modal");
        Modal.style.display = "none";
        this.facturation = false;
        this.payement = false;
        this.devis = false;
    }

    validatePayement(id: number) {
        this.acceptPaymentSub = this.api.acceptPayment(id).subscribe(data => {
            if (data == true) {
                let index = this.allOrder.findIndex(i => i.billingID == id);
                this.allOrder[index].transStatus = 3;
                this.generateValidationSub = this.api.validationCommande(0, new Date, false, id, false).subscribe(data => {
                    if (data != null) {
                        this.sendInvoiceCode();
                        this.closeModal();
                        this.payement = false;
                        this.openSnackBar("Paiement bien enregistré!", "Fermer");
                        this.refreshOrderList("5");
                        this.toggleTab('5', 'nav-stat5', 'nav-stat5-tab');
                    }
                    if (this.generateValidationSub != null) this.generateValidationSub.unsubscribe();
                }, error => {
                    this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "ValidationCommande", new Date().toString());
                    if (this.generateValidationSub != null) this.generateValidationSub.unsubscribe();
                    console.log(error);
                })
            } else {
                // Gestion d'erreurs à faire!
            }
            if (this.acceptPaymentSub != null) this.acceptPaymentSub.unsubscribe();
        }, error => {
            this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "acceptPayment", new Date().toString());
            if (this.acceptPaymentSub != null) this.acceptPaymentSub.unsubscribe();
            console.log(error);
        })
    }

    sendShippingFees() {
        this.api.setQuoteShippingFees(this.actualId, this.fdpDevisForm.value.fdpDevis).subscribe(data => {
            let index = this.allOrder.findIndex(i => i.billingID == this.actualId);
            this.allOrder[index].transStatus = 18;
            this.allOrder[index].fdpManuel = this.fdpDevisForm.value.fdpDevis;
            this.refreshOrderList("18");
        });



        this.closeModal();
    }

    sendInvoiceCode() {
        let index = this.allOrder.findIndex(i => i.billingID == this.actualId);
        if (this.invoiceForm.status == "VALID") {
            this.api.setInvoiceCode(this.invoiceForm.value.invoiceCode, this.actualId).subscribe(data => {
                if (data == true) {
                    this.allOrder[index].invoiceCode = this.invoiceForm.value.invoiceCode;
                    this.closeModal();
                    this.facturation = false;
                    this.openSnackBar("Numéro de facture renseigné", "Fermer");
                    this.refreshOrderList("5");
                    this.toggleTab('5', 'nav-stat5', 'nav-stat5-tab');
                }
            }, error => {
                console.log(error);
            })
        }
        if (this.sageForm.status == "VALID") {
            this.api.setSageCode(this.sageForm.value.sageCode, 0, this.actualId).subscribe(data => {
                if (data == true) {
                    this.allOrder[index].sageCode = this.sageForm.value.sageCode;
                    this.closeModal();
                    this.openSnackBar("Code renseigné", "Fermer");
                    this.refreshOrderList("5");
                    this.toggleTab('5', 'nav-stat5', 'nav-stat5-tab');
                }
            }, error => {
                console.log(error);
            });
        }
    }

    notifySending() {
        this.notifySendingSub = this.api.notifySending(this.actualId).subscribe(data => {
            if (data == true) {
                this.allOrder.find(i => i.billingID == this.actualId).isSended = true;
                this.openSnackBar("Notification expédition de commande envoyée", "Fermer");
                this.refreshOrderList("5");
                this.toggleTab('5', 'nav-stat5', 'nav-stat5-tab');
                this.closeShippingModal();
            }
            else { }
            if (this.notifySendingSub != null) this.notifySendingSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.notifySendingSub != null) this.notifySendingSub.unsubscribe();
        });
    }

    openShippingModal(billingID: number) {
        this.actualId = billingID;
        let modal = document.getElementById("shippingModal");
        modal.style.display = "block";
    }

    closeShippingModal() {
        let modal = document.getElementById("shippingModal");
        modal.style.display = "none";
    }

    sortScale(sort: Sort, status: string) {
        var data = this.orderLst;
        Constants.sortScale(sort, status, data)

        this.orderLst = data.slice();
        this.orderSource = new MatTableDataSource(this.orderLst);
    }

    changeFlagConserverRecherche() {
        this.conserverRecherche = !this.conserverRecherche;
    }

}
